import { Transactions } from '@unistocks/features/portfolios/transactions/transactions';
import { t } from '@unistocks/localization';
import { usePortfoliosGetQuery } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { HasId } from '@unistocks/types/has-id';
import { useLocalSearchParams, useNavigation } from 'expo-router';
import Head from 'expo-router/head';
import { useEffect } from 'react';

export default function TransactionsScreen() {
  const { id } = useLocalSearchParams<HasId>();
  const navigation = useNavigation();

  const { data: portfolio } = usePortfoliosGetQuery({ id }, { enabled: !!id });

  useEffect(() => {
    if (portfolio) {
      navigation.setOptions({ title: `${portfolio.name} | ${t('::Transactions')}` });
    }
  }, [navigation, portfolio]);

  let title = t('::Transactions');
  if (portfolio) {
    title = `${portfolio.name} | ${title}`;
  }

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Transactions id={id} />
    </>
  );
}
